/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge14 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							min-width: 700px;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id} delimiter-edge-14`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>   
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M340.8,24.4c0.5-1.6,1.8-2.6,3.1-3.5c0.9-0.6,1.5-1.3,1.8-2.4c0.2-0.6,0.5-1.1,0.8-1.6c0.6-0.9,1.5-1.3,2.6-1.2
				c1,0.1,1.8,0.5,2.1,1.6c0.3,1-0.1,1.9-0.9,2.4c-1.1,0.7-2.2,1.3-3.3,2c-0.8,0.5-1.7,0.9-2.2,1.8c0.4,1.1,1.3,1.1,2.2,1.2
				c1.7,0.2,3.4,0.3,5.1,0.5c1.3,0.1,2.5,0,3.6-0.8c1.3-1,2.7-0.8,4.1-0.1c1.1,0.6,1.7,1.4,1.6,2.6c-0.1,1.2-1,2.2-2.2,2.6
				c-1.1,0.3-2.3,0.4-3.2-0.4c-2-1.8-4.4-1.5-6.9-1.8c-0.2,1.6,0.5,2.5,1.9,3.2c1.9,0.9,2.1,2.2,0.7,3.6c-1,1-2.4,1-3.4-0.1
				c-0.7-0.7-0.8-1.6-1-2.5c-0.4-3.4-1.5-4.3-5-4.3c-4,0-8,0-12,0c-0.7,0-1.5-0.2-2.3,0.5c0.7,1.2,1.9,2.1,3,3c0.9,0.7,1.6,1.3,1.1,2.5
				c-0.4,1-1.8,1.4-3.1,1.1c-1.1-0.3-1.4-0.8-1.4-2.3c0-0.2,0-0.5,0-0.7c-0.4-0.8-1.1-1.1-1.6-1.6c-2-2.1-4.3-2.7-7.2-2.2
				c-1.8,0.3-3.7,0.2-5.6,0.3c-3.2,0.2-6.4,0.5-9.5,1.1c-0.1,1,0.5,1.2,1,1.5c1.2,0.8,2.4,1.6,3.2,2.8c0.4,0.7,1.2,0.9,1.9,1.2
				c0.7,0.4,1.4,0.8,1.4,1.7c0,0.9-0.6,1.4-1.4,1.6c-0.9,0.3-1.8,0.4-2.6-0.4c-0.1-0.1-0.3-0.3-0.3-0.4c-0.6-3.1-3.4-4.3-5.6-5.9
				c-1.5-1.2-3.2-1.5-5-1.1c-5,1-10.1,1.4-14.9,3.3c-0.5,0.2-1,0.3-1.5,0c-0.4-1.6-0.4-1.8,0.8-2.3c1.3-0.6,2.7-1,4.1-1.3
				c2.9-0.6,5.8-1.1,8.7-1.6c1.3-0.2,2.4-0.6,3.2-1.7c0.9-1.2,2.1-2.2,3.2-3.2c1.2-1.1,2.4-2,2.4-3.9c0-1.3,1.6-1.8,2.7-1
				c0.6,0.4,1.2,1,1.3,2c-2.6,1.4-3.7,4.4-6.6,6.1c1.4,0.7,2.2,0.3,3,0.2c4.4-0.6,8.9-1.1,13.4-1.1c2,0,3.9-0.4,5.2-2.1
				c0.4-0.5,1.1-0.8,1.6-1.2c0.8-0.6,1.4-1.3,1.6-2.4c0.3-1.8,1.7-2.5,3.6-2.2c0.8,0.2,1.4,0.6,1.7,1.4c0.2,0.8-0.3,1.3-0.9,1.7
				c-1.6,0.8-2.6,2.4-4.1,3.3c-0.3,0.2-0.5,0.5-0.4,0.9C326.6,24.8,337.6,24.9,340.8,24.4z"/>
			<path  fill={props.item.fill || "var(--force-contast-color)"} d="M163.2,25.8c-0.5-1.6-1.8-2.6-3.1-3.5c-0.9-0.6-1.5-1.3-1.8-2.4c-0.2-0.6-0.5-1.1-0.8-1.6
				c-0.6-0.9-1.5-1.3-2.6-1.2c-1,0.1-1.8,0.5-2.1,1.6c-0.3,1,0.1,1.9,0.9,2.4c1.1,0.7,2.2,1.3,3.3,2c0.8,0.5,1.7,0.9,2.2,1.8
				c-0.4,1.1-1.3,1.1-2.2,1.2c-1.7,0.2-3.4,0.3-5.1,0.5c-1.3,0.1-2.5,0-3.6-0.8c-1.3-1-2.7-0.8-4.1-0.1c-1.1,0.6-1.7,1.4-1.6,2.6
				c0.1,1.2,1,2.2,2.2,2.6c1.1,0.3,2.3,0.4,3.2-0.4c2-1.8,4.4-1.5,6.9-1.8c0.2,1.6-0.5,2.5-1.9,3.2c-1.9,0.9-2.1,2.2-0.7,3.6
				c1,1,2.4,1,3.4-0.1c0.7-0.7,0.8-1.6,1-2.5c0.4-3.4,1.5-4.3,5-4.3c4,0,8,0,12,0c0.7,0,1.5-0.2,2.3,0.5c-0.7,1.2-1.9,2.1-3,3
				c-0.9,0.7-1.6,1.3-1.1,2.5c0.4,1,1.8,1.4,3.1,1.1c1.1-0.3,1.4-0.8,1.4-2.3c0-0.2,0-0.5,0-0.7c0.4-0.8,1.1-1.1,1.6-1.6
				c2-2.1,4.3-2.7,7.2-2.2c1.8,0.3,3.7,0.2,5.6,0.3c3.2,0.2,6.4,0.5,9.5,1.1c0.1,1-0.5,1.2-1,1.5c-1.2,0.8-2.4,1.6-3.2,2.8
				c-0.4,0.7-1.2,0.9-1.9,1.2c-0.7,0.4-1.4,0.8-1.4,1.7c0,0.9,0.6,1.4,1.4,1.6c0.9,0.3,1.8,0.4,2.6-0.4c0.1-0.1,0.3-0.3,0.3-0.4
				c0.6-3.1,3.4-4.3,5.6-5.9c1.5-1.2,3.2-1.5,5-1.1c5,1,10.1,1.4,14.9,3.3c0.5,0.2,1,0.3,1.5,0c0.4-1.6,0.4-1.8-0.8-2.3
				c-1.3-0.6-2.7-1-4.1-1.3c-2.9-0.6-5.8-1.1-8.7-1.6c-1.3-0.2-2.4-0.6-3.2-1.7c-0.9-1.2-2.1-2.2-3.2-3.2c-1.2-1.1-2.4-2-2.4-3.9
				c0-1.3-1.6-1.8-2.7-1c-0.6,0.4-1.2,1-1.3,2c2.6,1.4,3.7,4.4,6.6,6.1c-1.4,0.7-2.2,0.3-3,0.2c-4.4-0.6-8.9-1.1-13.4-1.1
				c-2,0-3.9-0.4-5.2-2.1c-0.4-0.5-1.1-0.8-1.6-1.2c-0.8-0.6-1.4-1.3-1.6-2.4c-0.3-1.8-1.7-2.5-3.6-2.2c-0.8,0.2-1.4,0.6-1.7,1.4
				c-0.2,0.8,0.3,1.3,0.9,1.7c1.6,0.8,2.6,2.4,4.1,3.3c0.3,0.2,0.5,0.5,0.4,0.9C177.4,26.3,166.4,26.3,163.2,25.8z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M263.4,28.1c-1.8,0.1-3.2,0-4.6-0.6c-5.4-2.1-6.4-5-6.3-9.8c0.1-2.6,0.9-5.2,1.9-7.6c0.9-2,2.3-3.2,4.4-3.8
				c5.9-1.7,13.7,2.5,15.2,8.4c1.6,6-1.4,13-9.8,13.4C263.9,28.1,263.5,28.1,263.4,28.1z M268,23.1c-1.3,0.4-2.6,0.7-4,0.5
				c-2.3-0.4-4.2-1.4-5.1-3.6c-0.6-1.6-0.3-3.2,0.8-4.2c1.2-1.1,2.3-1,3.5,0.4c0,0.5-0.4,0.7-0.7,1c-1.7,1.3-1.7,2.3,0.1,3.4
				c0.6,0.4,1.4,0.7,2.1,0.8c1.8,0.1,3.3-1.2,3.4-3c0.1-2.2-2-4.8-4.2-4.7c-3.1,0.1-6,1.1-7.7,4.1c-0.7,1.3-0.8,2.5,0,3.8
				c2.5,4.3,8.2,5.2,12,1.8c2.9-1.6,4.3-5.3,3.3-8.2c-1.2-3.5-4.6-5.1-8.8-4.4c0.4,0.4,1,0.2,1.4,0.3c3.1,0.4,4.9,2.3,6,5.1
				c1,2.5,0.1,4.6-1.6,6.4C268.3,22.7,268.1,22.9,268,23.1z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M231.9,30.1c0-3.1,0.8-6,2.3-8.7c1.8-3.4,5.3-5.1,9.1-4.6c0.8,0.1,1.5,0.3,2.2,0.4c3.8,0.6,5.9,2.8,6.9,6.5
				c1.1,4.1-2.7,13.2-5.7,15.1c-3.3,2.1-6.7,2.3-10.1,0.7c-3.3-1.6-4.7-4.5-4.8-8.1C231.9,30.9,231.9,30.5,231.9,30.1z M249.2,22.6
				c0,0,0.1,0.1,0.1,0.1C249.3,22.7,249.2,22.7,249.2,22.6c-0.1-0.4-0.2-0.8-0.5-1l-0.1-0.1l0.1,0.1C248.7,22,248.9,22.4,249.2,22.6z
				M248.2,32.3c-2.7,1.4-5.4,1.6-8.2,0.2c-2.9-1.4-3.5-4.3-4.8-6.9c-0.9,2.3-1.2,5.6-0.8,7.4c0.4,1.5,1.2,2.8,2.5,3.7
				C241.1,39.8,246.7,37.7,248.2,32.3z M238.7,24.5c1.5-0.5,3-0.9,4.5-0.3c1.4,0.5,2.9,1.1,4.7,2.1c-0.3-0.9-0.4-1.3-0.6-1.7
				c-0.5-0.8-0.9-1.6-1.5-2.4c-2.2-3.1-3.7-3.9-6.6,0.3C238.8,22.9,238.5,23.4,238.7,24.5z M242.1,27.5c1,0.3,0.7,1.5,1.6,1.7
				c0.8,0,1.3-0.4,1.4-1.5c-1.5-0.8-2.8-2.2-4.7-1c-0.7,0.4-1.3,1.2-0.8,2.3C240.5,28.4,240.9,27.3,242.1,27.5z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M260.1,29.3c1.5,0,3.4,0.4,5.2,1.2c3.4,1.6,4.8,4.8,3.8,8.4c-0.3,1.1-0.7,2.3-1.4,3.2c-1.4,2-3.3,3.2-5.7,3.2
				c-4,0-7.4-1.5-9.9-4.7c-2.5-3.3-1.7-7.6,1.8-9.9C255.7,29.6,257.2,29.2,260.1,29.3z M255.3,40.5c-0.2-0.2-0.3-0.3-0.5-0.5
				c-0.3-2.3,0.9-4.5,0.7-7c-3.3,2-3.4,4.3-0.7,7C255,40.1,255.2,40.3,255.3,40.5c0.3,0.3,0.6,0.4,1,0.5c2.6,2.7,8.2,2.8,8.8-0.2
				c-1.7,0.6-3.3,1.4-5.1,1.1c-1.2-0.2-2.4-0.6-3.7-0.9C256.1,40.6,255.7,40.5,255.3,40.5z M261.8,39c2-0.2,3.3-1.4,3.2-2.9
				c-0.1-1.2-0.9-1.9-1.7-2.7c-0.8-0.8-1.7-1.4-3.2-0.8C263.1,34.2,262.6,36.5,261.8,39z M259.4,37.2c0.7-0.8,0.7-1.5-0.1-2
				c-0.1-0.1-0.6,0-0.6,0.1C258.1,36.2,258.6,36.7,259.4,37.2z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M290.6,13.4c-1.3-0.7-2.3-1.3-1.9-2.8c0.3-1.2,1.5-2.1,2.8-2.2c1.5-0.1,2.2,0.9,1.7,2.2
				C292.8,11.9,291.9,12.8,290.6,13.4z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M288.1,23.5c-0.9-0.1-1.5-0.5-1.9-1.2c-0.4-0.8-0.1-1.5,0.5-2.1c0.6-0.6,1.4-1,2.3-1c1.4,0.1,2.1,1.2,1.3,2.5
				C289.8,22.5,289.2,23.4,288.1,23.5z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M286.6,16.5c-0.4,1.4-1.4,1.8-2.4,2.2c-0.8,0.3-1.5,0.1-2-0.6c-0.5-0.8-0.4-1.6,0.2-2.3
				C283.6,14.2,285.1,14.5,286.6,16.5z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M245.4,4.7c-1.3,0-1.9-0.8-1.4-2c0.6-1.5,2.3-2.2,3.7-1.5c1.1,0.6,1.2,1.6,0.3,2.4
				C247.2,4.4,246.3,4.7,245.4,4.7z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M234.2,46c-1.1,1.8-2,2.3-3.2,1.9c-0.9-0.3-1.5-0.8-1.5-1.8c0-0.9,0.6-1.3,1.4-1.6
				C232.3,44,232.8,44.2,234.2,46z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M234.4,8.8c-0.9,0-1.4-0.7-1.4-1.7c0-1.3,1-2.2,2.3-2.2c1,0,1.6,0.6,1.6,1.5C236.9,7.5,235.5,8.8,234.4,8.8z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M243.9,10.5c0.1,1-0.8,1.9-1.9,1.9c-1,0.1-1.8-0.4-1.8-1.3c-0.1-1.1,0.8-2.1,2-2.1
				C243.2,9,243.8,9.6,243.9,10.5z"/>
			<path fill={props.item.fill || "var(--force-contast-color)"} d="M242.5,44.7c-0.1,1.1-1.1,1.9-2.3,1.8c-1-0.1-1.6-0.7-1.6-1.6c0.1-1.1,1.1-1.9,2.3-1.8
				C241.9,43.2,242.5,43.9,242.5,44.7z"/>
					</svg>
	</div>
}

